import ApiBudgety from '@/api/apiBudgety'
import { MenusSistema } from '@/Helper/Segurity'

export const hitoService = {
  guardarHito,
  verDocumentoAdjunto,
  guardarDocumentoAdjunto,
  getAllToFacturar,
  guardarDocumentoFacturaHes,
}

async function getAllToFacturar(body) {
  return await ApiBudgety.post('Hito/FindToFacturar/', body)
}

async function guardarHito(hito, idUsuario) {
  return await ApiBudgety.post('Hito/InsertOrUpdate/' + idUsuario, hito, {
    headers: {
      ACCION: MenusSistema.proyecto_gestion.accesos.editar_hito,
      MENU: MenusSistema.proyecto_gestion.id,
    },
  })
}

async function verDocumentoAdjunto(idHito) {
  return await ApiBudgety.get('Hito/VerDocumentoAdjunto/' + idHito, {
    responseType: 'blob', // Indica a Axios que la respuesta será un blob
  })
}

async function guardarDocumentoAdjunto(idTipoDocumento, idHito, fileName, file) {
  const formData = new FormData()
  formData.append('file', file) // Agrega el archivo al FormData

  return await ApiBudgety.post(`Hito/GuardarDocumentoAdjunto?fileName=${fileName}&idHito=${idHito}&idTipoDocumento=${idTipoDocumento}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      ACCION: MenusSistema.proyecto_gestion.accesos.editar_hito,
      MENU: MenusSistema.proyecto_gestion.id,
    },
  })
}

async function guardarDocumentoFacturaHes(idHito, idTipoDocumento, file, body) {
  const formData = new FormData()
  formData.append('file', file)
  return await ApiBudgety.post(
    `Hito/GuardarDocumentoFacturaHes?idTipoDocumento=${idTipoDocumento}&idHito=${idHito}&fechaDocAdjuntado=${body.fechaDocAdjuntado}&numeroDoc=${body.numeroDoc}&comentario=${body.comentario}`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        ACCION: MenusSistema.proyecto_gestion.accesos.editar_hito,
        MENU: MenusSistema.proyecto_gestion.id,
      },
    }
  )
}
